import $ from 'jquery';
import { openSelectOptions, selectOption, cr_state } from '@/select-box.js';
import { openMenu, closeMenu, open_menu_state, convertDateToYyyyMmDd } from '@/function/function.js';
import moment from 'moment'
import TraiterConduite from '@/views/consultations/modal-traiter-conduite'
import TraiterSoinsSansConsultation from '@/views/consultations/modal-traite-soins-sans-consultation'

export default {
    name: 'dashboard-sage-femme',
    components: {
        
        TraiterConduite,
        TraiterSoinsSansConsultation
    },
    props: [],
    data() {
        return {
            user_id: 0,
            vm_state: open_menu_state,
            curr_state: cr_state,
            monthConsultationsLoading: false,
            jr_selected: 'Aujourd\'hui',
            mm_selected: 'Mars',
            consult_month_selected: {
                french: null
            },
            selectedConsultation: null,
            date: new Date(),
            monthsLatest: new Array(),

            drp_menu_class: [],

            liste_conduites: [], //  Liste des conduites du jour
            cat_loading: true,
            selectedConduite: null,
            selectedMoment: null,
            soins_sans_consult: [],
            soin_selected: {},
            heure_selected: '',
            type_cons_abr: 'CPN',

            fields: ['patient', 'sexe', 'contact', 'consultation', { key: 'est_valide', label: 'Validités' }],
            filter: "",
            tableIsBusy: true,
            perPage: 20,
            currentPage: 1,

            suite_is_loading: true,
            suite_is_empty: false,
            salle_is_loading: true,
            salle_is_empty: false
        }
    },
    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        countEnAttente() {
            if (this.consultationsEnAttente == null) {
                return 0;
            } else {
                return this.consultationsEnAttente.length;
            }
        },

        monthConsultations() {
            return this.$store.getters['currentMonthConsultationsCount'];
        },

        months() {
            return this.monthsOfYear();
        },

        latestMonthsOfCurrentYear() {
            let index;

            for (index = 0; index < this.date.getMonth() + 1; index++) {
                this.monthsLatest[index] = this.months[index];
            }
            return this.monthsLatest;
        },

        consultationsEnAttente() {
            return this.$store.getters['consultationsEnAttente'];
        },

        countTodayConsultations() {
            return this.$store.getters['todayConsultationsCount']
        },

        currentMonth() {
            return this.latestMonthsOfCurrentYear[this.date.getMonth()];
        },

        // 
        currentCAT() {
            return this.$store.getters['cat'];
        },

        suitesSoins() {
            return this.$store.getters['suitesDeSoins'];
        }
    },
    mounted() {
        this.user_id = this.userCredentials.id

        // Suite de CPN
        this.refreshSuiteDeSoins() 

        setTimeout(() => {
            $('.shw1').fadeIn()
        }, 500);
        setTimeout(() => {
            $('.shw2').fadeIn()
        }, 700);
        setTimeout(() => {
            $('.shw3').fadeIn()
        }, 900);

        setTimeout(() => {
            $('.shw4').fadeIn()
        }, 900);


        this.consult_month_selected = this.currentMonth;
        this.$store.dispatch('getCountMonthConsultations', { month: this.currentMonth.english, type_cons: this.type_cons_abr });

        // Consultation CPN en attente
        this.refreshSalleAttente()

        this.$store.dispatch('getCountTodayConsultations', this.type_cons_abr);
        let date_cat = convertDateToYyyyMmDd.convertDate(this.date);

        this.$store.dispatch('getSoinsCPN', { date_cat: date_cat }).then((response) => {
            this.liste_conduites = response
            this.cat_loading = false;
        });
        this.$store.commit("SET_SELECTED_CONSULTATION_ENCOURS", {});
    },
    
    methods: {
        goToConsultation(patient_id, tarif_consultation_id) {
            const data = {
                patient_id: patient_id,
                tarif_consultation_id: tarif_consultation_id
            }
            console.log("C: ",data);
            this.$store.commit("SET_SELECTED_CONSULTATION_ENCOURS", data);
            this.$router.push({ path: 'patients/'+patient_id+'/consulter' })
        },


        properJson(data){
            try {
               return JSON.parse(data)
            } catch(e){
                return data

            }
        },
        formatHour: function(date){
            let formattedDate = moment(date)

            return formattedDate.format('HH:mm');
        },
        customDateFormat(given_date) {
            if (!given_date)
                given_date = new Date()

            let only_date = "",
                only_hour = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            only_date = date.getDate() + "/" + month + "/" + date.getFullYear();
            let c_hour = date.getHours();
            let c_minute = date.getMinutes();
            if (c_hour < 10) c_hour = "0" + c_hour;
            if (c_minute < 10) c_minute = "0" + c_minute;
            only_hour = c_hour + ":" + c_minute;

            return {
                date: only_date,
                hour: only_hour
            }
        },

        /**
         * Rafraichir la salle d'attente
         * @returns 
         */
        // refreshSalleAttente() {
        //     this.$store.dispatch('getConsultationsEnAttente', this.type_cons_abr)
        // },

        refreshSalleAttente() {
            this.salle_is_loading = true
            this.$store.dispatch('getConsultationsEnAttente', { auth_id: this.user_id, type_consultation: 'CPN'}).then(() => {
                if (this.consultationsEnAttente.length > 0) {
                    this.salle_is_empty = false
                } else {
                    this.salle_is_empty = true
                }
                this.salle_is_loading = false
            })
        },

        /**
         * Rafraichir la salle d'attente
         * @returns 
         */
        refreshSuiteDeSoins() {
            this.suite_is_loading = true
            this.$store.dispatch('getSuitesSoinsCpn', { auth_id: this.user_id, type_consultation: 'CPN'}).then(() => {
                if (this.suitesSoins.length > 0) {
                    this.suite_is_empty = false 
                } else {
                    this.suite_is_empty = true 
                }
                this.suite_is_loading = false
            })
        },

        selectSoin(soin, heure) {
            this.soin_selected = soin;
            this.heure_selected = heure
                // console.log('type', this.soin_selected)
        },
        /**
         * Rafraichir la liste des traitements à faire
         */
        refreshTraitement() {
            let date_cat = convertDateToYyyyMmDd.convertDate(this.date);
            this.$store.dispatch('getSoinsCPN', {  date_cat: date_cat }).then((response) => {
                this.liste_conduites = response
                console.log("Liste des cat : ", this.currentCAT)
            });
            

        },

        monthsOfYear: function() {

            var month = new Array()
            month = [{
                    "french": "Janvier",
                    "english": "January"
                },
                {
                    "french": "Février",
                    "english": "February",
                },
                {
                    "french": "Mars",
                    "english": "March",
                },
                {
                    "french": "Avril",
                    "english": "April",
                },
                {
                    "french": "Mai",
                    "english": "May",
                },
                {
                    "french": "Juin",
                    "english": "June",
                },
                {
                    "french": "Juillet",
                    "english": "July",
                },
                {
                    "french": "Aout",
                    "english": "August",
                },
                {
                    "french": "Septembre",
                    "english": "September",
                },
                {
                    "french": "Octobre",
                    "english": "October",
                },
                {
                    "french": "Novembre",
                    "english": "November",
                },
                {
                    "french": "Decembre",
                    "english": "December",
                },
            ]

            return month
        },
        /**
         * Show select options in dropdown
         * @param {int} j_state 
         * @param {string} selector 
         */
        async openSelectOption(j_state, selector) {
            this.curr_state = openSelectOptions.openSelectOption(j_state, selector)
        },

        /**
         * Select option in dropdown
         * @param {string} selected_value
         * @param {string} selected_id 
         * @param {string} selector 
         * @param {string} model_selector 
         */
        async selectOption(selected_value, selected_id, selector, model_selector) {
            this.curr_state = selectOption.chooseOption(selected_id, selector)

            switch (model_selector) {
                case 'jr':
                    this.jr_selected = selected_value;
                    break;
                case 'mm':
                    this.mm_selected = selected_value;
                    break;
                case 'cm':
                    this.consult_month_selected = selected_value;
                    this.monthConsultationsLoading = true
                    this.$store.dispatch('getCountMonthConsultations', { month: this.consult_month_selected.english, type_cons: this.type_cons_abr }).then(
                        () => {
                            this.monthConsultationsLoading = false
                        }
                    )
            }
            console.log(selected_id); //  Recuperer ici l'ID de l'option choisi
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        /**
         * Traiter une conduite
         * @param {*} t_cat 
         */
        treatCAT: function(t_cat, ccat) {
            this.selectedConduite = t_cat
            this.selectedMoment = ccat

            console.log("CONDUITE: ", t_cat)
            console.log("MOMOENT: ", ccat)
        },

        /**
         * 
         * @param {*} route 
         */
        routeTo(route) {
            this.$router.push({ path: route })
        }
    }
}